/* eslint-disable no-unused-expressions */
/* eslint-disable no-lone-blocks */
import { useAuth0 } from "@auth0/auth0-react";
import AuthService from "Lib/API/Auth";
import CommunicationService from "Lib/API/Communication/index";
import FinanceSettingService from "Lib/API/FinanceSetting/FinanceSetting";
import MembersSettingService from "Lib/API/MemberSetting/MemeberSetting";
import { DateFormetContext } from "app/App.js";
import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import BackSvgComponent from "assets/icons/svg/back";
import DatePickers from "components/DatePicker/DatePicker";
import InfoTooltip from "components/InfoTooltip";
import MultipleInput from "components/Multiple";
import MyButton from "components/MyButton";
import SearchBar from "components/Search";
import Button from "components/button/Button";
import { getDateFormat, getDateFormatForDatePicket, maskDate } from "helper/dateFormat.js";
import * as _ from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import Select, { components } from "react-select";
import MaskedInput from "react-text-mask";
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import { capitalizeFirstLetter } from "utils/functions";
import { collectionDisplayName, fetchProducts, filterOrder, filterParameters } from "./filterSlice";
import "./index.scss";


const selectControlStyles = {
  backgroundColor: "#FFFFFF",
  border: "1px solid #ebedf3",
  color: "#030303",
  transition:
    "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
  paddingTop: "6px",
  paddingBottom: "6px",
  cursor: "pointer",
  fontSize: "14px",
};
const colourStyles = {
  control: (styles) => ({
    ...styles,
    ...selectControlStyles,
  }),
  menuList: (styles) => ({
    ...styles,
    maxHeight: "150px",
    fontSize: "14px",
    color: "#030303",
  }),
};
const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <BottomArrowSvg label="Emoji" />
    </components.DropdownIndicator>
  );
};

const ParameterValue = ({ onClick, id, audienceRow,goToInfo,formik}) => {
  const dateMask = maskDate();
  const dateFormatPlaceholder = getDateFormat();
  const dateFormat = getDateFormatForDatePicket();

  const autoCorrectedDatePipe = createAutoCorrectedDatePipe(dateFormat || "mm/dd/yyyy");

  const dateFormet = React.useContext(DateFormetContext);
  const dispatch = useDispatch();
  const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;

  const filterParamsInitial = useSelector(
    (state) => state?.filterParams?.fieldsGroup
  );
  const [preSavedData, setPreSavedData] = useState();
  const [filters, setFilters] = useState(filterParamsInitial || {});
  const [searchTerm, setValue] = useState("");
  const [parameter, setParameter] = useState([]);
  const [operator, setOperator] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tags, setTags] = React.useState([]);
  const [accountTags, setAccountTags] = useState([]);
  const [accountTagsLoading, setAccountTagsLoading] = useState(false);
  const [contactTags, setContactTags] = useState([]);
  const [contactTagsLoading, setContactTagsLoading] = useState(false);
  const [selectedMultiValue, setSelectedMultiValue] = useState({});
  const [accountTypes, setAccountTypes] = useState([]);
  const [accountCategories, setAccountCategories] = useState([]);
  const [accountCategoriesLoading, setAccountCategoriesLoading] = useState(false);
  const [billingTypes, setBillingTypes] = useState([]);
  const [billingTypesLoading, setBillingTypesLoading] = useState(false);
  const [getFilterByIdLoading, setGetFilterByIdLoading] = useState(true);

  const enableLoading = (value) => {
    setLoading(value);
  };
  const exceptThisSymbols = ["e", "E", "+", "-"];

  const preventArrows = (e) => {
    if (e.which === 38 || e.which === 40 || exceptThisSymbols.includes(e.key))
      e.preventDefault();
  };
  const { getAccessTokenSilently } = useAuth0();
  const queryParams = new URLSearchParams(window.location.search);
  const filterId = id;
  const [date, setDate] = useState([]);
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;


  const setApplyValues = (key, list) => {
    const selectedFilterData = Object.keys(filterParamsInitial)?.length ? filterParamsInitial : filters;
    const filterValue = typeof selectedFilterData?.[key]?.values === 'string' ? selectedFilterData?.[key]?.values?.split(" , ")
    : Array.isArray(selectedFilterData?.[key]?.values?.[0]) ? selectedFilterData?.[key]?.values?.[0] : selectedFilterData?.[key]?.values;
    if (filterValue?.length > 0) {
      const filterSelectedValues = list?.filter((item) => {
        const found = filterValue?.find((value) => value === item?.key);
        if (found && found != undefined) {
          return item;
        }
      });
      filterSelectedValues?.length && setSelectedMultiValue((prev) => {
        return {
          ...prev,
          [key]: filterSelectedValues,
        };
      }
      )
    }
  }


  const getAccountTagsHandler = async () => {
    const token = await getAccessTokenSilently();
    setAccountTagsLoading(true);
    AuthService.getTags(
      'account',
      "",
      "",
      token
    )
      .then((res) => {
        const tags = res?.result;
        const filterTags = tags?.map((item) => {
          return {
            label: item?.title,
            key: item?.title,
            value: item?._id,
          };
        });
        setAccountTags(filterTags);
        setApplyValues("account.tags", filterTags)
      })
      .catch((err) => {
        console.log('err: ', err);
        toastr.error('Error', err?.data?.message || 'Something went wrong');
      }).finally(() => {
        setAccountTagsLoading(false);
      });
  };
  const getContactTagsHandler = async () => {
    const token = await getAccessTokenSilently();
    setContactTagsLoading(true);
    AuthService.getTags(
      'contact',
      "",
      "",
      token
    )
      .then((res) => {
        const tags = res?.result;
        const filterTags = tags?.map((item) => {
          return {
            label: item?.title,
            key: item?.title,
            value: item?._id,
          };
        });
        setContactTags(filterTags);
        setApplyValues("tags", filterTags)
      })
      .catch((err) => {
        console.log('err: ', err);
        toastr.error('Error', err?.data?.message || 'Something went wrong');
      }).finally(() => {
        setContactTagsLoading(false);
      });
  };
  const getAccountCategoriesHandler = async () => {
    setAccountCategoriesLoading(true);
    const token = await getAccessTokenSilently();
    MembersSettingService.getCatagoryListByType(
      "", token
    )
      .then((res) => {
        const accountCategories = res?.result;
        const filterAccountCategories = accountCategories?.map((item) => {
          return {
            label: item?.title,
            key: item?.title,
            value: item?._id,
          };
        });
        setAccountCategories(filterAccountCategories);
        setApplyValues("account.payment.account_sub_type.title", filterAccountCategories)
      })
      .catch((err) => {
        console.log('err: ', err);
        toastr.error('Error', err?.data?.message || 'Something went wrong');
      }).finally(() => {
        setAccountCategoriesLoading(false);
      });
  };

  const getBillingTypesHandler = async () => {
    setBillingTypesLoading(true);
    const token = await getAccessTokenSilently();
    FinanceSettingService.getAccountBillingTypes(token)
      .then((res) => {
        const billingTypes = res?.result;
        const filterBillingTypes = billingTypes?.map((item) => {
          return {
            label: item?.title,
            key: item?.title,
            value: item?._id,
          };
        });
        setBillingTypes(filterBillingTypes);
        setApplyValues("account.payment.billing_type.title", filterBillingTypes)

      })
      .catch((err) => {
        console.log('err: ', err);
        toastr.error('Error', err?.data?.message || 'Something went wrong');
      }).finally(() => {
        setBillingTypesLoading(false);
      });
  }

  const getAccountTypesHandler = async () => {
    const accountTypes = [
      {
        label: "Member",
        key: "member",
        value: "member"
      },
      {
        label: "Not a Member",
        key: "non-member",
        value: "non-member"
      },
      {
        label: "Organization",
        key: "organization",
        value: "organization"
      }
    ]
    setAccountTypes(accountTypes);
    setApplyValues("account.payment.account_type", accountTypes);
  };

  useEffect(() => {
    if (getFilterByIdLoading && id ) return;
    getAccountTagsHandler();
    getContactTagsHandler();
    getAccountTypesHandler();
    getAccountCategoriesHandler();
    getBillingTypesHandler();
  }, [getFilterByIdLoading]);

  const getFilterById = async () => {
    if (id != null) {
      setGetFilterByIdLoading(true);
      const token = await getAccessTokenSilently();
      await CommunicationService.getAudienceById(id, token).then((res) => {
        let tempFilter = {};
        if(Object.keys(filters).length) return;
        res?.result?.filter?.selectedFields.map((ele) => {
          let tempStr = "";
          ele?.fieldName.split("_").forEach((ele) => {
            const str2 = ele.charAt(0).toUpperCase() + ele.slice(1);
            tempStr += " " + str2;
          });
          const values = typeof ele?.fieldValue === 'string' || typeof ele?.fieldValue === 'number' ? [ele?.fieldValue] : ele?.fieldValue 

          const result = values?.join(' , ');

          tempFilter = {
            ...filters,
            ...tempFilter,
            [ele.fieldName]: {
              collectionName: ele?.collectionName,
              displayName: ele?.displayName,
              fieldName: ele?.fieldName,
              operator: ele?.operator,
              oprInputType: ele?.type,
              values: ele?.fieldValue?.length > 0 ?
                ele?.type === "bool" ? ele?.fieldValue :
                  result
                : ele?.fieldValue[0],
              form: "edit"
            },
          };
        });
        console.log('tempFilter', tempFilter)
        setFilters(tempFilter);
      }).catch((err) => {
        console.log('erreeee', err)
        toastr.error("Error", err?.data?.message);
      }).finally(() => {
        setGetFilterByIdLoading(false);
      });
    }
  };
  React.useEffect(() => {
    // if (getPreviousVal) {
      getFilterById();
    // }
  }, []);

  React.useEffect(() => {
    let parameterDataFromApi = [];
    let operatorDataFromApi = [];
    async function fetchMyAPI() {
      const token = await getAccessTokenSilently();
      await AuthService.getFilterParams(token)
        .then((res) => {
          enableLoading(true);
          if (res.length) {
            parameterDataFromApi = res;
            setParameter(res);
          }
          enableLoading(false);
        })
        .catch((err) => {
          enableLoading(false);
          toastr.error("Error", err?.data?.message);
        });

      await AuthService.getOperatorParams(token)
        .then((res) => {
          enableLoading(true);
          if (res.length) {
            operatorDataFromApi = res;
            setOperator(res);
          }
          enableLoading(false);
        })
        .catch((err) => {
          enableLoading(false);
          console.log('Aerr', err)
          toastr.error("Error", err?.data?.message);
        });
      console.log('filterId', filterId,"audienceRow",audienceRow)
      let tempFilter = {}
      // {
      //   filterId
      //     ? CommunicationService.getAudienceById(filterId, token)
      //       .then((res) => {
      //         console.log('res.filter.selectedFields', res,res?.result?.filter?.selectedFields,filterParamsInitial)
      //         setPreSavedData(res);
      //         let newData = filterParamsInitial || {};
      //         const updatedData = res?.result?.filter?.selectedFields.map(
      //           ({ fieldName, collectionName, fieldValue, operator, type }) => {
      //             const foundData = _.find(
      //               parameterDataFromApi,
      //               (item) => item.collectionName === collectionName
      //             );
      //             if (foundData) {
      //               const foundFieldsGroup = _.find(
      //                 foundData.fieldsGroup,
      //                 (item) => item.fieldName === fieldName
      //               );
      //               if (foundFieldsGroup) {
      //                 const foundOperator = _.find(
      //                   operatorDataFromApi,
      //                   (item) => item.oprId === operator
      //                 );
      //                 newData = {
      //                   ...newData,
      //                   [fieldName]: {
      //                     operator: operator,
      //                     oprInputType: foundOperator?.oprInputType || 0, //need to chnage
      //                     values: fieldValue[0],
      //                     fieldName,
      //                     displayName: foundFieldsGroup?.displayName,
      //                     collectionName: collectionName,
      //                     type: type
      //                   },
      //                 };
      //               }
      //             }
      //           }
      //         );
      //         console.log('newData', newData)
      //         // setFilters(newData);
      //       })
      //       .catch((err) => { })
      //     : {};
      // }
    }
    fetchMyAPI();
  }, [filterId, filterParamsInitial, getAccessTokenSilently]);
  /**
   * Adds value to filter by given key
   * @param {any} value
   */
  const addFilter = (filterName, item) => {
    const { fieldName, displayName, type } = filterName;
    setFilters({
      ...filters,
      [fieldName]: {
        operator: null,
        oprInputType: type ?? operator[0].oprInputType,
        values: null,
        fieldName,
        displayName,
        collectionName: item?.collectionName,
      },
    });
  };

  /**
   * Remove object value from given
   * @param {any} value, object key
   */
  const removeFilter = (value) => {
    let newFilters = {};
    const filtered = Object.keys(filters).filter((key) => key !== value);
    filtered.forEach((key) => {
      newFilters[key] = filters[key];
    });
    setFilters(newFilters);
  };

  /**
   * Handles the click evnet of the tag
   * @param {any} filterName, Name of the filter
   */
  const handleClick = async (filterName, item) => {
    /**
     * Add the filter if not exist else remove it from object
     */
    addFilter(filterName, item);
    await dispatch(collectionDisplayName(item?.collectionName));
  };

  const setOperatorToFilter = (operatorId, filterName, type) => {
    setFilters((filt) => {
      return {
        ...filt,
        [filterName]: {
          ...filt[filterName],
          operator: operatorId,
          values: null,
          form: 'add',
          oprInputType: type ?? operator.find((o) => o.oprId == operatorId)
            .oprInputType,
        },
      };
    });
  };

  function convertLocalToUTCDate(name, date) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    );
    handleOperaterValueChange(name, date);
    // formik.setFieldValue(name, date);
    return date;
  }

  const handleOperaterValueChange = (filterName, value) => {
    setFilters((filt) => {
      return {
        ...filt,
        [filterName]: {
          ...filt[filterName],
          values: [value],
        },
      };
    });
  };
  



  const multiSelectOptions = {
    "account.tags": accountTags,
    "tags": contactTags,
    "account.payment.account_type": accountTypes,
    "account.payment.account_sub_type.title": accountCategories,
    "account.payment.billing_type.title": billingTypes,
  }

  const multiSelectOptionsLoading = {
    "account.tags": accountTagsLoading,
    "tags": contactTagsLoading,
    "account.payment.account_type": false,
    "account.payment.account_sub_type.title": accountCategoriesLoading,
    "account.payment.billing_type.title": billingTypesLoading,
  }

  const dateRangeValue = (date) => {
    if (!date) return [];
    const dateRange = typeof date === "string" ? date?.split(",") : date;
    const startDate = moment(dateRange[0]).toDate();
    const endDate = moment(dateRange[1]).toDate();
    return [startDate, endDate];
  }



  const getBooleanValue = (value) => {
    if (value == undefined) return "";
    if (typeof value === "array") return value?.[0] == "true" ? "1" : "0";
    return value == "true" ? "1" : "0";
  }

  const getOprInputValue = (filterKey) => {
    const selectOp = filters[filterKey].oprInputType;
    switch (selectOp) {
      case "text":
        if (filters[filterKey].operator === 7 || filters[filterKey].operator === 8) {
          return (
            <div className="params-values">
              <div className="multi-input-value">
                <MultipleInput
                  prevTags={filters[filterKey].values}
                  setFilters={setFilters}
                  filters={filters}
                  keyData={filterKey}
                  setTags={setTags}
                  tags={tags}
                />
              </div>
            </div>
          );
        }
        else {
          return (
            <div className="params-values">
              <input
                type="text"
                className="input-value"
                onChange={(e) =>
                  handleOperaterValueChange(filterKey, e.target.value)
                }
                value={filters[filterKey].values || ""}
                required={filters[filterKey].values !== ""}
              />
            </div>
          );
        }
      case "number":
        if (filters[filterKey].operator === 7 || filters[filterKey].operator === 8) {
          return (
            <div className="params-values">
              <div className="multi-input-value">
                <MultipleInput
                  prevTags={filters[filterKey].values}
                  setFilters={setFilters}
                  filters={filters}
                  keyData={filterKey}
                  setTags={setTags}
                  tags={tags}

                />
              </div>
            </div>
          );
        }
        return (
          <div className="params-values">
            <input
              type="number"
              onWheel={(e) => e.target.blur()}
              onKeyDown={(e) => preventArrows(e)}
              className="input-value"
              required={filters[filterKey].values !== ""}
              value={filters[filterKey].values || ""}
              onChange={(e) =>
                handleOperaterValueChange(
                  filterKey,
                  e.target.value
                  // e.target.value.match(regex)[0]
                )
              }
            />
          </div>
        );
      case "multiplechoice":
        return (
          <div className="params-values">
            <div className="multi-input-value">
              <MultipleInput
                prevTags={filters[filterKey].values}
                setFilters={setFilters}
                filters={filters}
                keyData={filterKey}
                setTags={setTags}
                tags={tags}
              />
            </div>
          </div>
        );
      case "list":
        return (
          <div className="params-values">
            <div className="multi-input-value">
              <MultipleInput
                prevTags={filters[filterKey].values}
                setFilters={setFilters}
                filters={filters}
                keyData={filterKey}
                setTags={setTags}
                tags={tags}
              />
            </div>
          </div>
        );
      case "date":
        if (filters[filterKey].operator === 10) {
          return (
            <div className="params-values">
              <DateRangePicker 
                format={dateFormat}
                placeholder={`${dateFormatPlaceholder}  ~  ${dateFormatPlaceholder}`}
                cleanable={true}
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                style={
                  {
                    display: "inline-block",
                    padding: '0',
                    border: '0',
                    width: "100%",
                    color: 'black'
                  }
                }
                size="lg"
                value={date?.length ? date : dateRangeValue(filters[filterKey].values)}
                onChange={(update) => {
                  const [startDate, endDate] = update;
                  let data = filters;
                  data[filterKey].values = [
                    moment(startDate).format(dateFormet),
                    moment(endDate).format(dateFormet),
                  ];
                  setFilters(data);
                  setDateRange(update);
                  setDate(update)
                }} />
            </div>
          );
        }
        else
          return (
            <div className="params-values">
              <div className="form-group">
                <DatePicker
                  showIcon
                  placeholderText={dateFormatPlaceholder}
                  dateFormat={dateFormat}
                  selected={
                    (typeof filters?.[filterKey]?.values === 'string') ? new Date(filters[filterKey].values) : Array.isArray(filters?.[filterKey]?.values) &&
                      filters[filterKey]?.values?.[0]
                  }
                  onChange={(e) => {
                    convertLocalToUTCDate(filterKey, e);
                  }}
                  customInput={
                    <MaskedInput
                      pipe={autoCorrectedDatePipe}
                      mask={dateMask}
                      keepCharPositions={true}
                      guide={true}
                    />
                  }
                />
                {/* } */}
              </div>
            </div>
          );
      case "daterange":
        return (
          <div className="params-values">
            <DateRangePicker
              format={dateFormat}
              placeholder={`${dateFormatPlaceholder}  ~  ${dateFormatPlaceholder}`}
              cleanable={true}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              style={
                {
                  display: "inline-block",
                  padding: '0',
                  border: '0',
                  width: "100%",
                  color: 'black'
                }
              }
              size="lg"
              value={date}
              onChange={(update) => {
                const [startDate, endDate] = update;
                let data = filters;
                data[filterKey].values = [
                  moment(startDate).utcOffset("+0100").format(dateFormet),
                  moment(endDate).utcOffset("+0100").format(dateFormet),
                ];
                setFilters(data);
                setDateRange(update);
                setDate(update)
              }} />

          </div>
        );
      case "textlike":
        return (
          <div className="params-values">
            <input
              className="input-value"
              value={filters[filterKey].values || ""}
              onChange={(e) =>
                handleOperaterValueChange(filterKey, e.target.value)
              }
            />
          </div>
        );

      case "multiSelect":
        return (
          <div className="params-values mt-2">
            <Select
              classNamePrefix="react-select"
              options={multiSelectOptions[filterKey]}
              isMulti
              isLoading={multiSelectOptionsLoading[filterKey]}
              styles={colourStyles}
              onChange={(items) => {
                if (filters[filterKey]) {
                  handleOperaterValueChange(filterKey, items.map((item) => item.key))
                }
                setSelectedMultiValue((prev) => {
                  return {
                    ...prev,
                    [filterKey]: items,
                  };
                }
                )
              }}
              value={selectedMultiValue[filterKey]}
              components={{ DropdownIndicator }}
            />
          </div>

        );
      default:
        return "";
      case "bool":
        return (
          <div className="params-values mt-2">
            <select
              name="operators"
              className="params-values-selection"
              onChange={(e) => {
                handleOperaterValueChange(filterKey, e.target.value === "1" ? true : false)
              }}
              value={getBooleanValue(filters[filterKey]?.values)}
            >
              <option value="" disabled selected hidden>Select option</option>
              <option value={"1"}>
                Yes
              </option >
              <option value={"0"}>
                No
              </option>
            </select>
          </div>
        );
    }
  };

  const isMissingValue = (value) =>
    value === null ||
    value === undefined ||
    (typeof value === "string" && !value.trim()) ||
    value === "Invalid date" ||
    (Array.isArray(value) &&
      (!value.length || value.some((item) => isMissingValue(item))));

  const handleNextDisabled = () => {
    return Object.values(filters).some(
      ({ operator, values }) =>
        !operator ||
        (![12, 13].includes(operator) && isMissingValue(values))
    );
  };

  async function sendData() {
    if (handleNextDisabled()) return;
    console.log('filters', filters)
    const token = await getAccessTokenSilently();

    await dispatch(filterParameters(filters));
    const result = await dispatch(
      fetchProducts({ data: { filters }, formik:formik,token })
    );
    if (fetchProducts.fulfilled.match(result)) onClick();
  }

  return (
    <div className="parameter-values">
      <div className="heading">Choose Parameters & Value</div>
      <div className="details">
        <div className="parameter">
          <div className="parameter-form communication__parameter-form">
            <div className="parameter-head" style={{ display: 'flex', alignItems: 'center' }}>
              PARAMETERS
              <InfoTooltip text="Click a field to add it as a filter condition. Fields are grouped by record type (e.g. Account, Member) — adding multiple conditions narrows the audience to people matching ALL of them." placement="bottom" useFixed style={{ marginLeft: '6px' }} />
            </div>
            <div className="filter-search-bar pb-2 pt-2">
              <SearchBar searchTerm={searchTerm} setValue={setValue} />
            </div>
            <div className="communication__parameter-fields">
              {parameter?.map((item, index) => {
                return (
                  <div className="member-search" key={index}>
                    <div className="member-head">{item?.collectionName}</div>
                    <div className="search-items">
                      {item?.fieldsGroup
                        .filter(
                          (value) =>
                            value.displayName
                              .toLowerCase()
                              .includes(searchTerm.toLowerCase()) &&
                            !_.find(
                              filters,
                              (item) => item.displayName === value.displayName
                            )
                        )
                        .map((data, index) => {
                          return (
                            <div
                              key={index}
                              className={`search-options ${data.fieldName in filters ? "active" : ""
                                }`}
                              onClick={() => handleClick(data, item)}
                            >
                              {data?.displayName}
                            </div>
                          );
                        })}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="vallues">
          <div className="parameter-form">
            <div className="parameter-head" style={{ display: 'flex', alignItems: 'center' }}>
              VALUES
              <InfoTooltip text="The Operator options change based on the field you picked — text fields offer choices like Equals or Contains, while date fields offer choices like Before, After, or Between." placement="bottom" useFixed style={{ marginLeft: '6px' }} />
            </div>
            {!Object.keys(filters).length ? (
              <div className="choose-parameter-text">
                <span>Please choose from the</span>
                <span>Parameters in the left box</span>
              </div>
            ) : (
              Object.keys(filters).map((filterKey, index) => (
                <div className="parameter-value" key={index}>
                  <div className="value-options">
                    <div className="search-value-fielt">Field Name:</div>
                    <div className="search-value-operator">Operator:</div>
                    <div className="search-value-input">Values:</div>
                  </div>
                  <div className="field-params-values">
                    <div className="params-field-name">
                      {filters[filterKey].displayName}
                    </div>
                    <div className="params-operator">
                      {/* <select name="operators" className="search-operator" onChange={(e) => setSelectOp(filters?.oprDisplay)}> */}
                      <select
                        name="operators"
                        className="search-operator"
                        onChange={(e) => {
                          setOperatorToFilter(
                            Number(e.target.value),
                            filterKey,
                            filters[filterKey].oprInputType
                          );
                          if (filterKey === "account.tags" || filterKey === "tags") {
                            setSelectedMultiValue((prev) => {
                              return {
                                ...prev,
                                [filterKey]: [],
                              };
                            }
                            )
                          }
                        }}
                        value={filters[filterKey].operator}
                      >
                        <option selected="true" disabled="disabled">
                          Select option
                        </option>

                        {operator.map((item, index) => (
                          <>
                            {
                              item?.types.includes(filters[filterKey].oprInputType) &&
                              <option value={item.oprId} key={index}>
                                {capitalizeFirstLetter(item.oprDisplay)}
                              </option>
                            }
                          </>

                        ))}
                      </select>
                    </div>
                    <div className="params-values">
                      {getOprInputValue(filterKey)}
                    </div>
                  </div>
                  <div className="back-button">
                    <BackSvgComponent onClick={() => removeFilter(filterKey)} />
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
      <hr />
      <div className="buttons-inside-audience-parameter">
        <Button
          style={{ minWidth: "100px", marginBottom: "25px" }}
          onClick={goToInfo}
          variant="primary-outline"
          size="md"
        >
          <span>Previous</span>
        </Button>
        <Button
          content="Next"
          style={{ minWidth: "100px", marginBottom: "25px" }}
          onClick={sendData}
          disabled={
            handleNextDisabled() || !Object.keys(filters).length ? true : false
            // !Object.keys(filters).length ? true : false
          }
          variant="primary"
          size="md"
        >
          <span>Next</span>
        </Button>
      </div>
    </div>
  );
};

export default ParameterValue;
